import unique from 'lodash/uniq';

export function filterPurposesByGroup(groups, pages) {
  let purposesByGroup = {};

  const groupMap = new Map();
  groups.forEach(({ groupId, groupName }) => groupMap.set(groupId, groupName));

  groupMap.forEach((value, key) => {
    const filtered = pages.filter(x => x.userGroupId === key);
    const purposes = unique(filtered.map(x => x.section.sectionName));
    purposesByGroup = {
      ...purposesByGroup,
      [value]: purposes,
    };
  });

  return purposesByGroup;
}

export function filterPagesForGivenGroupAndPurpose(
  groupId,
  purposeName,
  pages,
) {
  const filteredPages = pages.filter(page => (
    page.userGroupId === groupId && page.section.sectionName === purposeName
  ));
  return filteredPages;
}

// Removes any text inside Parenthesis and Square Brackets
// These assumptions are made as the API only return these 2 scenarios at the same time
// For example, all sheets come back with [Group] (Purpose) SheetName format
export function beautifyPageNames(data) {
  const expression = /(\[.*?\]).*?(\(.*\))/g;
  const pages = data.map((p) => {
    const invalidCharacters = p.name.search(expression);
    if (invalidCharacters > -1) {
      return {
        ...p,
        name: p.name.replace(expression, '').trim(),
      };
    }
    return p;
  });
  return pages;
}
